/* eslint-disable @typescript-eslint/camelcase */

import React from 'react'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from 'styled-components'
import { theme } from '@elamajs/ui-kit'

import { Chart } from '../Visualisation/components'
import * as Styled from '../Visualisation/Visualisation.styled'
import { CPMChart } from './charts'
import { useData } from './hooks'
import { ChartSize } from '../Visualisation/types'
import Filters from './Filters'
import ContactsPerItemChart from './charts/ContactsPerItemChart'

import * as AnalyticsStyled from './AnalyticsAvito.styled'

const Visualisation = () => {
  const { data, fetchData, isFetching } = useData()

  return (
    <>
      <AnalyticsStyled.Title>Аналитика Авито по&nbsp;тематикам</AnalyticsStyled.Title>
      <Styled.Main data-sticky-container>
        <Filters data={data} isFetching={isFetching} fetchData={fetchData} />
        <Styled.Body>
          <Styled.Row>
            <Styled.FlexContainer>
              <Chart
                graphHeight={ChartSize.LARGE}
                title={<>Средняя цена товара&nbsp;/ услуги в&nbsp;объявлении</>}
                tooltip={
                  <>
                    Показатели рассчитываем по медианным <br /> значениям
                  </>
                }
                data={data?.data.average_price_category_item}
                withAverage
                averageCurrencyType="RUB"
                averageHiddenOnMobile={false}
              >
                <CPMChart
                  data={data?.data.average_price_category_item}
                  graphHeight={ChartSize.LARGE}
                />
              </Chart>
            </Styled.FlexContainer>
          </Styled.Row>
          <Styled.Row>
            <Chart
              graphHeight={ChartSize.LARGE}
              title={<>Спрос на&nbsp;одно объявление в&nbsp;категории</>}
              tooltip={
                <>
                  Как вычисляем: делим количество всех <br /> объявлений в категории на среднее{' '}
                  <br /> количество запросов контактов
                </>
              }
              data={data?.data.contacts_per_item}
              averageCurrencyType=""
              averageHiddenOnMobile={false}
            >
              <ContactsPerItemChart
                data={data?.data.contacts_per_item}
                graphHeight={ChartSize.LARGE}
                unit=""
              />
            </Chart>
          </Styled.Row>
          <Styled.Row>
            <Styled.FlexContainer>
              <Chart
                graphHeight={ChartSize.LARGE}
                title={<>Сколько стоит один просмотр</>}
                tooltip={
                  <>
                    Показатели рассчитываем по медианным <br /> значениям
                  </>
                }
                data={data?.data.cost_viewing}
                withAverage
                averageCurrencyType="RUB"
                averageHiddenOnMobile={false}
              >
                <CPMChart data={data?.data.cost_viewing} graphHeight={ChartSize.LARGE} />
              </Chart>
            </Styled.FlexContainer>
          </Styled.Row>
          <Styled.Row>
            <Chart
              graphHeight={ChartSize.LARGE}
              title={<>Сколько просмотров получает объявление</>}
              tooltip={
                <>
                  Показатели рассчитываем по медианным <br /> значениям
                </>
              }
              data={data?.data.views_per_item}
              averageCurrencyType=""
              averageHiddenOnMobile={false}
            >
              <ContactsPerItemChart
                data={data?.data.views_per_item}
                graphHeight={ChartSize.LARGE}
                unit=""
              />
            </Chart>
          </Styled.Row>
          <Styled.Row>
            <Chart
              graphHeight={ChartSize.LARGE}
              title={<>Конверсия из просмотра в контакт</>}
              tooltip={
                <>
                  Как вычисляем: делим количество <br /> просмотров на&nbsp;число любых запросов{' '}
                  <br /> контакта (например, если пользователь <br /> кликнул на «Показать номер»
                  или написал <br />в чат). Данные учитываем по всем <br /> объявлениям в категории{' '}
                  <br /> — с&nbsp;продвижением и без
                </>
              }
              data={data?.data.conversion_contact_from_viewing}
              averageCurrencyType="%"
              averageHiddenOnMobile={false}
            >
              <ContactsPerItemChart
                data={data?.data.conversion_contact_from_viewing}
                graphHeight={ChartSize.LARGE}
                unit="%"
              />
            </Chart>
          </Styled.Row>
        </Styled.Body>
      </Styled.Main>
    </>
  )
}

const withProviders = (Component: React.ComponentType) => {
  const NewComponent: React.ComponentType = () => {
    return (
      <ThemeProvider theme={theme}>
        <IntlProvider locale="ru">
          <Component />
        </IntlProvider>
      </ThemeProvider>
    )
  }

  return NewComponent
}

export default withProviders(Visualisation)
